import React from 'react';
import { Edit, FormTab, TabbedForm } from 'react-admin';
import PermanentPlacementFormToolbar from './PermanentPlacementFormToolbar';
import PermanentPlacementDetailsTab from './formTabs/PermanentPlacementDetailsTab';

const AssignmentsEdit = () => (
  <Edit redirect="show" mutationMode="pessimistic" data-testid="assignments-edit">
    <TabbedForm toolbar={<PermanentPlacementFormToolbar />} mode="onTouched">
      <FormTab label="Job Details" data-testid="job-details-tab">
        <PermanentPlacementDetailsTab />
      </FormTab>
    </TabbedForm>
  </Edit>
);

export default AssignmentsEdit;
